import { zonedTimeToUtc } from 'date-fns-tz'

const getDateInUserTimezone = (dateString: string | Date): Date => {
  const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone
  return zonedTimeToUtc(dateString, timeZoneName)
}

export default getDateInUserTimezone
